(() => {
  const SELECTORS = {
    scope: '[data-solvi-product-scope]',
    productInfo: 'product-info',
    mediaWrapper: '.product__media-wrapper',
    mediaItem: '.product__media-item',
    activeMedia: '.product__media-item.swiper-slide-active, .product__media-item.is-active, .product__media-item[aria-hidden="false"]'
  };

  const cloneFirstElement = (template) => {
    if (!template || !template.content) return null;
    const element = template.content.firstElementChild;
    return element ? element.cloneNode(true) : null;
  };

  const mountAfter = (scope, templateSelector, hostSelector, marker) => {
    const productInfo = document.querySelector(SELECTORS.productInfo);
    const host = productInfo && productInfo.querySelector(hostSelector);
    const template = scope.querySelector(templateSelector);
    if (!host || !template || document.querySelector(`[data-solvi-mounted="${marker}"]`)) return;

    const element = cloneFirstElement(template);
    if (!element) return;
    element.dataset.solviMounted = marker;
    host.insertAdjacentElement('afterend', element);
  };

  const mountInside = (scope, templateSelector, hostSelector, marker) => {
    const productInfo = document.querySelector(SELECTORS.productInfo);
    const host = productInfo && productInfo.querySelector(hostSelector);
    const template = scope.querySelector(templateSelector);
    if (!host || !template || host.querySelector(`[data-solvi-mounted="${marker}"]`)) return;

    const element = cloneFirstElement(template);
    if (!element) return;
    element.dataset.solviMounted = marker;
    host.appendChild(element);
  };

  const directChildWithin = (element, ancestor) => {
    let branch = element;
    while (branch && branch.parentElement !== ancestor) branch = branch.parentElement;
    return branch;
  };

  const setupPurchaseRow = () => {
    const productInfo = document.querySelector(SELECTORS.productInfo);
    if (!productInfo) return;

    const quantity = productInfo.querySelector('.product-form__quantity, .product__quantity, quantity-input');
    const submit = productInfo.querySelector('.product-form__submit');
    if (!quantity || !submit) return;

    const permittedContainers = '.product__block--buy_buttons, product-form, .product-form, form, .product-form__buttons';
    let container = quantity.parentElement;
    while (container && container !== productInfo) {
      if (container.matches(permittedContainers) && container.contains(submit)) break;
      container = container.parentElement;
    }
    if (!container || container === productInfo) return;

    const quantityBranch = directChildWithin(quantity, container);
    const submitBranch = directChildWithin(submit, container);
    if (!quantityBranch || !submitBranch || quantityBranch === submitBranch) return;

    container.classList.add('solvi-product-purchase-row');
    quantityBranch.classList.add('solvi-product-purchase-row__quantity');
    submitBranch.classList.add('solvi-product-purchase-row__submit');
  };

  const setupCounter = (mediaWrapper, galleryUi) => {
    const counter = galleryUi.querySelector('[data-solvi-gallery-count]');
    const previousButton = galleryUi.querySelector('[data-solvi-gallery-prev]');
    const nextButton = galleryUi.querySelector('[data-solvi-gallery-next]');
    if (!counter || counter.dataset.solviReady === 'true') return;
    counter.dataset.solviReady = 'true';

    const update = () => {
      const mediaItems = Array.from(mediaWrapper.querySelectorAll(SELECTORS.mediaItem)).filter(
        (item) => !item.classList.contains('swiper-slide-duplicate')
      );
      if (!mediaItems.length) {
        counter.textContent = '01 / 01';
        if (previousButton) previousButton.disabled = true;
        if (nextButton) nextButton.disabled = true;
        return;
      }

      const active = mediaWrapper.querySelector(SELECTORS.activeMedia);
      const activeIndex = Math.max(0, mediaItems.indexOf(active));
      counter.textContent = `${String(activeIndex + 1).padStart(2, '0')} / ${String(mediaItems.length).padStart(2, '0')}`;
      if (previousButton) previousButton.disabled = activeIndex <= 0;
      if (nextButton) nextButton.disabled = activeIndex >= mediaItems.length - 1;
    };

    const moveGallery = (direction) => {
      const nativeSelector = direction === 'previous'
        ? '.swiper-button-prev, .slider-button--prev'
        : '.swiper-button-next, .slider-button--next';
      const nativeButton = mediaWrapper.querySelector(nativeSelector);

      if (nativeButton && !nativeButton.disabled && nativeButton.getAttribute('aria-disabled') !== 'true') {
        nativeButton.click();
        return;
      }

      const swiperHost = Array.from(mediaWrapper.querySelectorAll('.swiper, .swiper-container')).find(
        (element) => element.swiper && typeof element.swiper.slideNext === 'function'
      );
      if (!swiperHost) return;
      if (direction === 'previous') swiperHost.swiper.slidePrev();
      else swiperHost.swiper.slideNext();
    };

    previousButton?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      moveGallery('previous');
      window.setTimeout(update, 50);
    });

    nextButton?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      moveGallery('next');
      window.setTimeout(update, 50);
    });

    update();

    const observer = new MutationObserver(update);
    mediaWrapper.querySelectorAll(SELECTORS.mediaItem).forEach((item) => {
      observer.observe(item, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
    });

    mediaWrapper.addEventListener('click', () => requestAnimationFrame(update));
    mediaWrapper.addEventListener('transitionend', update);
  };

  const clearCardPositionStyles = (card) => {
    if (!card) return;
    [
      'position',
      'top',
      'right',
      'bottom',
      'left',
      'inset',
      'inset-inline-start',
      'inset-inline-end',
      'width',
      'min-width',
      'max-width',
      'height',
      'margin',
      'margin-left',
      'margin-right',
      'transform',
      'translate',
      'z-index',
      'display',
      'opacity',
      'visibility'
    ].forEach((property) => card.style.removeProperty(property));
  };

  const closeCard = (card) => {
    if (!card || !card.classList.contains('is-open')) return;

    card.classList.remove('is-open');
    card.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('solvi-scent-card-open');

    const placeholder = card._solviPlaceholder;
    const galleryUi = card._solviGalleryUi;
    const mediaWrapper = card._solviMediaWrapper;
    const note = card._solviNote;

    clearCardPositionStyles(card);

    if (placeholder?.parentNode) {
      placeholder.parentNode.insertBefore(card, placeholder);
      placeholder.remove();
    }

    if (note) {
      note.style.removeProperty('opacity');
      note.style.removeProperty('visibility');
    }

    card._solviPlaceholder = null;

    if (galleryUi && mediaWrapper) {
      requestAnimationFrame(() => enforceMobileGalleryComposition(mediaWrapper, galleryUi));
    }
  };

  const setupCard = (galleryUi) => {
    const card = galleryUi.querySelector('[data-solvi-scent-card]');
    const note = galleryUi.querySelector('.solvi-scent-card-note');
    if (!card || card.dataset.solviReady === 'true') return;
    card.dataset.solviReady = 'true';

    card._solviGalleryUi = galleryUi;
    card._solviMediaWrapper = galleryUi.closest(SELECTORS.mediaWrapper);
    card._solviNote = note;

    card.addEventListener('click', () => {
      const willOpen = !card.classList.contains('is-open');

      if (!willOpen) {
        closeCard(card);
        return;
      }

      const placeholder = document.createComment('solvi-scent-card-placeholder');
      card.parentNode.insertBefore(placeholder, card);
      card._solviPlaceholder = placeholder;

      clearCardPositionStyles(card);

      if (note) {
        note.style.setProperty('opacity', '0', 'important');
        note.style.setProperty('visibility', 'hidden', 'important');
      }

      document.body.appendChild(card);
      card.classList.add('is-open');

      /*
       * Force the open card onto the real viewport center.
       * Inline !important prevents theme/Safari positioning rules
       * from pulling it toward the left edge.
       */
      card.style.setProperty('position', 'fixed', 'important');
      card.style.setProperty('inset', 'auto', 'important');
      card.style.setProperty('top', '50%', 'important');
      card.style.setProperty('left', '50%', 'important');
      card.style.setProperty('right', 'auto', 'important');
      card.style.setProperty('bottom', 'auto', 'important');
      const mobileOpenCard = globalThis.matchMedia('(max-width: 767px)').matches;

      card.style.setProperty(
        'width',
        mobileOpenCard
          ? 'min(calc(100vw - 28px), 620px, calc((100dvh - 32px) * 0.72))'
          : 'min(380px, calc(100vw - 48px), calc((100dvh - 48px) * 0.72))',
        'important'
      );
      card.style.setProperty('min-width', '0', 'important');
      card.style.setProperty('max-width', mobileOpenCard ? 'none' : '380px', 'important');
      card.style.setProperty('height', 'auto', 'important');
      card.style.setProperty('margin', '0', 'important');
      card.style.setProperty('z-index', '999999', 'important');
      card.style.setProperty('transform', 'translate3d(-50%, -50%, 0) rotate(-0.5deg)', 'important');
      card.style.setProperty('transform-origin', 'center center', 'important');
      card.style.setProperty('opacity', '1', 'important');
      card.style.setProperty('visibility', 'visible', 'important');

      card.setAttribute('aria-expanded', 'true');
      document.body.classList.add('solvi-scent-card-open');
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeCard(card);
    });

    document.addEventListener('click', (event) => {
      if (card.classList.contains('is-open') && !card.contains(event.target)) closeCard(card);
    });
  };

  const enforceMobileGalleryComposition = (mediaWrapper, galleryUi) => {
    const compact = globalThis.matchMedia('(max-width: 767px)').matches;

    const viewer = mediaWrapper.querySelector('.product__media-gallery-viewer-wrap');
    const card = galleryUi.querySelector('.solvi-scent-card');
    const note = galleryUi.querySelector('.solvi-scent-card-note');
    const stack = galleryUi.querySelector('.solvi-product-gallery-scrap--stack');

    mediaWrapper.style.setProperty('overflow', 'visible', 'important');
    galleryUi.style.setProperty('overflow', 'visible', 'important');

    if (stack) {
      stack.hidden = false;
      stack.removeAttribute('hidden');
    }

    /*
     * Position the CLOSED card from the actual visible Polaroid bounds.
     * This avoids relying on galleryUi's computed width, which can differ
     * between Shopify's editor and real mobile Safari.
     */
    if (viewer && card && !card.classList.contains('is-open')) {
      const mediaRect = mediaWrapper.getBoundingClientRect();
      const viewerRect = viewer.getBoundingClientRect();

      if (viewerRect.width > 0 && mediaRect.width > 0) {
        const cardWidth = compact
          ? Math.round(Math.min(150, Math.max(132, viewerRect.width * 0.38)))
          : Math.round(Math.min(210, Math.max(155, viewerRect.width * 0.34)));
        const cardHeight = cardWidth * (100 / 72);

        // Anchor the same lower-right overlap to the visible Polaroid at every width.
        const edgeHang = compact ? 18 : 12;
        const noteShift = compact ? 22 : 18;
        const left = viewerRect.right - mediaRect.left - cardWidth + edgeHang;

        // Recreate the original lower-right overlap from the working version.
        const top = viewerRect.bottom - mediaRect.top - (cardHeight * 0.74);

        card.style.position = 'absolute';
        card.style.top = `${Math.round(top)}px`;
        card.style.left = `${Math.round(left)}px`;
        card.style.right = 'auto';
        card.style.bottom = 'auto';
        card.style.width = `${cardWidth}px`;
        card.style.minWidth = '0';
        card.style.maxWidth = 'none';
        card.style.height = 'auto';
        card.style.display = 'block';
        card.style.opacity = '1';
        card.style.visibility = 'visible';

        if (note) {
          note.style.position = 'absolute';
          note.style.top = `${Math.round(top + cardHeight + 8)}px`;
          note.style.left = `${Math.round(left + noteShift)}px`;
          note.style.right = 'auto';
          note.style.bottom = 'auto';
          note.style.width = `${cardWidth}px`;
          note.style.display = 'block';
          note.style.opacity = '1';
          note.style.visibility = 'visible';
          note.style.textAlign = 'center';
        }
      }
    }
  };

  const setupGallery = (scope) => {
    const productInfo = document.querySelector(SELECTORS.productInfo);
    const mediaWrapper = productInfo && productInfo.querySelector(SELECTORS.mediaWrapper);
    const template = scope.querySelector('[data-solvi-gallery-ui-template]');
    if (!mediaWrapper || !template) return false;

    if (scope.dataset.polaroidEnabled === 'true') {
      mediaWrapper.classList.add('solvi-polaroid-gallery');
    }

    const owner = scope.dataset.sectionId;
    let galleryUi = mediaWrapper.querySelector(`[data-solvi-gallery-ui][data-solvi-owner="${owner}"]`);
    const freshGalleryUi = cloneFirstElement(template);
    if (!freshGalleryUi) return false;

    if (galleryUi) {
      document.body.classList.remove('solvi-scent-card-open');
      galleryUi.replaceWith(freshGalleryUi);
      galleryUi = freshGalleryUi;
    } else {
      galleryUi = freshGalleryUi;
      mediaWrapper.appendChild(galleryUi);
    }

    mediaWrapper.classList.toggle(
      'solvi-gallery-has-stack-art',
      Boolean(galleryUi.querySelector('.solvi-product-gallery-scrap--stack'))
    );

    setupCounter(mediaWrapper, galleryUi);
    setupCard(galleryUi);

    const reposition = () => enforceMobileGalleryComposition(mediaWrapper, galleryUi);
    reposition();
    requestAnimationFrame(reposition);
    window.setTimeout(reposition, 120);
    window.setTimeout(reposition, 450);

    galleryUi.querySelectorAll('img').forEach((image) => {
      if (!image.complete) {
        image.addEventListener('load', reposition, { once: true });
      }
    });

    if ('ResizeObserver' in window) {
      const viewer = mediaWrapper.querySelector('.product__media-gallery-viewer-wrap');
      const resizeObserver = new ResizeObserver(reposition);
      resizeObserver.observe(mediaWrapper);
      if (viewer) resizeObserver.observe(viewer);
    }

    return true;
  };

  const runScopeSetup = (scope) => {
    if (!scope || !scope.isConnected) return;

    const galleryReady = setupGallery(scope);
    setupPurchaseRow();
    mountInside(scope, '[data-solvi-smells-doodle-template]', '.solvi-product-smells', 'smells-doodle');
    mountAfter(scope, '[data-solvi-quantity-doodle-template]', '.product-form__quantity, .product__quantity, quantity-input', 'quantity-doodle');
    mountAfter(scope, '[data-solvi-sample-doodle-template]', '.solvi-product-sample-link', 'sample-doodle');

    if (galleryReady) {
      scope.dataset.solviInitialized = 'true';
      scope.dataset.solviPending = 'false';
      scope.dataset.solviAttempts = '0';
      return;
    }

    const attempts = Number(scope.dataset.solviAttempts || 0) + 1;
    scope.dataset.solviAttempts = String(attempts);

    if (attempts < 40) {
      window.setTimeout(() => runScopeSetup(scope), 250);
    } else {
      scope.dataset.solviPending = 'false';
    }
  };

  const initializeScope = (scope) => {
    if (!scope || scope.dataset.solviInitialized === 'true' || scope.dataset.solviPending === 'true') return;
    scope.dataset.solviPending = 'true';
    scope.dataset.solviAttempts = '0';
    runScopeSetup(scope);
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll(SELECTORS.scope).forEach(initializeScope);
  };

  const repositionAllMobileGalleries = () => {
    document.querySelectorAll('[data-solvi-gallery-ui]').forEach((galleryUi) => {
      const mediaWrapper = galleryUi.closest(SELECTORS.mediaWrapper);
      if (mediaWrapper) enforceMobileGalleryComposition(mediaWrapper, galleryUi);
    });
  };

  window.addEventListener('resize', () => requestAnimationFrame(repositionAllMobileGalleries), { passive: true });
  window.addEventListener('orientationchange', () => window.setTimeout(repositionAllMobileGalleries, 120), { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll(SELECTORS.scope).forEach((scope) => {
      scope.dataset.solviInitialized = 'false';
      scope.dataset.solviPending = 'false';
      scope.dataset.solviAttempts = '0';
    });
    initializeAll();
  });
})();
